<template>
    <Head :titulo="programa.nombre" />
    <div class="hero-bloque-mascara">
      <div class="hero-bloque-mascara__img">
        <img src="/img/hero-bloque-img-mascara.png" alt="">
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <h1 class="hero-encabezado">{{ programa.nombre }}</h1>
            <div class="hero-etiquetas">
              <span class="badge etiqueta-simple">Programa {{ programa.tipo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contenido-wrapper">
      <div class="bloque-general">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="breadcrumb-block-wrapper">
                <ul class="breadcrumb-block">
                  <li class="breadcrumb-block__item">
                    <a href="/programas" class="breadcrumb-block__section">Programas</a>
                  </li>
                  <li class="breadcrumb-block__item">
                    <Link :href="'/programas?secretaria=' + programa.secretaria.id" class="breadcrumb-block__section">{{ programa.secretaria.nombre }}</Link>
                  </li>
                  <li class="breadcrumb-block__item active">
                    <span class="breadcrumb-block__section">{{ programa.nombre }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bloque-general">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-7">
              <div class="contenido-administrable">
                <h6><strong>Tipo de Programa</strong></h6>
                <span class="badge etiqueta-simple">Programa {{ programa.tipo }}</span>
                <h6><strong>Objetivo del Programa</strong></h6>
                <p>{{ programa.informacion_corta }}</p>
                <h6><strong>Descripción del Programa</strong></h6>
                <p class="mb-4" v-html="programa.informacion" />
                <h6><strong>¿A quién va dirigido?</strong></h6>
                <p class="mb-4" v-html="programa.dirigido" />
                <h6 v-if="programa.solicitar!=null"><strong>¿Dónde solicitarlo?</strong></h6>
                <p v-if="programa.solicitar!=null" class="mb-4" v-html="programa.solicitar" />
                <h6 v-if="programa.vigencia!=null"><strong>Vigencia</strong></h6>
                <p v-if="programa.vigencia!=null" class="mb-4" v-html="programa.vigencia" />
              </div>
              <div class="bloque-boton" v-if="programa.archivo != null">
                <a :href="'/storage/'+programa.archivo+'?u='+new Date().valueOf().toString()" target="_blank" class="boton-principal boton-descarga" download><font-awesome-icon icon="fa-regular fa-file-pdf" /> Descargar Archivo del Programa</a>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="sidebar__wrapper">
                <!--<div class="sidebar__seccion-cta fondo-gris-claro">
                  <h6 class="sidebar__encabezado">Trámite en línea</h6>
                  <h4 class="sidebar__subencabezado">¡Realizar tu tramite es muy sencillo!</h4>
                  <a href="#" class="boton-secundario boton-flecha">Iniciar programa</a>
                </div>-->
                <BannersBox :banners="banners" />
                <div class="item-contacto">
                  <a :href="'tel:'+this.$telefono" class="link-telefono">{{ this.$telefono }}</a>
                  <Link href="/contacto" class="link-contacto">Contáctanos aquí</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
import { Link } from '@inertiajs/inertia-vue3'
import BannersBox from '../../Shared/Banners/BannersBox.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-regular-svg-icons'
library.add(faFilePdf);

export default {
    props:{
        programa: Object,
        banners: Object,
    },
    components:{
        Head, Link, BannersBox
    }
}
</script>
<style scoped>

</style>
